import { useMutation, useQuery } from "@tanstack/react-query";
import { createFirebaseAuthAxios } from "@/lib/firebase/authAxios";
import { newsletterService } from "./newsletter.service";

const api = createFirebaseAuthAxios();
const newsletterApi = newsletterService(api);

export function useSubscribeToNewsletter() {
  return useMutation({
    mutationFn: (email: string) => newsletterApi.subscribe(email),
  });
}

export function useUnsubscribeFromNewsletter() {
  return useMutation({
    mutationFn: (token: string) => newsletterApi.unsubscribe(token),
  });
}

interface UseNewsletterSubscribersParams {
  status?: string;
  search?: string;
  enabled?: boolean;
  basePath?: string;
}

export function useNewsletterSubscribers({
  status,
  search,
  enabled = true,
  basePath,
}: UseNewsletterSubscribersParams = {}) {
  return useQuery({
    queryKey: ["newsletter-subscribers", status, search, basePath],
    queryFn: () => newsletterApi.getSubscribers({ status, search }, basePath),
    enabled,
  });
}
